/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

export const serviceDeskInternalNotificationsNextGenRedirect = ({
	match,
}: RouteContext): React.JSX.Element => {
	const { projectKey } = match.params;

	const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
	return <Redirect to={url} />;
};
